import { App, Department, AppFilters } from '../types/app';
import { getAccessToken, signIn, oktaAuth } from './auth';

const API_URL = process.env.REACT_APP_API_URL || 'http://localhost:5050/api';

let isRedirecting = false;

async function fetchJson<T>(url: string): Promise<T> {
  const token = await getAccessToken();
  const headers: Record<string, string> = {};
  if (token) {
    headers['Authorization'] = `Bearer ${token}`;
  }

  const response = await fetch(url, { headers });
  if (response.status === 401 && !isRedirecting) {
    isRedirecting = true;
    await oktaAuth.tokenManager.clear();
    await signIn(window.location.pathname);
    throw new Error('Session expired');
  }
  if (!response.ok) {
    throw new Error(`HTTP error! status: ${response.status}`);
  }
  return response.json();
}

export const appService = {
  async getAll(filters?: AppFilters): Promise<App[]> {
    const params = new URLSearchParams();

    if (filters?.departmentId) {
      params.append('departmentId', filters.departmentId.toString());
    }
    if (filters?.status) {
      params.append('status', filters.status);
    }
    if (filters?.isOkta !== undefined) {
      params.append('isOkta', String(filters.isOkta));
    }

    const queryString = params.toString();
    const url = `${API_URL}/apps${queryString ? `?${queryString}` : ''}`;

    return fetchJson<App[]>(url);
  },

  async getById(id: number): Promise<App> {
    return fetchJson<App>(`${API_URL}/apps/${id}`);
  },
};

export const departmentService = {
  async getAll(): Promise<Department[]> {
    return fetchJson<Department[]>(`${API_URL}/departments`);
  },

  async getWithAppCount(filters?: { isOkta?: boolean }): Promise<Department[]> {
    const params = new URLSearchParams();
    if (filters?.isOkta !== undefined) {
      params.append('isOkta', String(filters.isOkta));
    }
    const queryString = params.toString();
    return fetchJson<Department[]>(`${API_URL}/departments/with-count${queryString ? `?${queryString}` : ''}`);
  },
};
